import { render, staticRenderFns } from "./statistical-analysis-view-detail-chart-type-charts.vue?vue&type=template&id=977fd54e&scoped=true&"
import script from "./statistical-analysis-view-detail-chart-type-charts.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-view-detail-chart-type-charts.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-view-detail-chart-type-charts.scss?vue&type=style&index=0&id=977fd54e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977fd54e",
  null
  
)

export default component.exports